import { Pipe, type PipeTransform } from '@angular/core';
import { type SidebarItem } from '../../utils/layout-config.utils';

@Pipe({
  name: 'sidebarChildActive',
  standalone: true,
})
export class SidebarChildActivePipe implements PipeTransform {
  transform(sidebarItem: SidebarItem, selectedItem?: string): boolean {
    return (
      (sidebarItem.subItems?.some((subItem) => subItem.name === selectedItem) ??
        false) &&
      selectedItem !== sidebarItem.name
    );
  }
}
